import { LoaderSpinner } from '@lightspeed/design-system-react'
import React, { FC } from 'react'
import { LSPAYModalContent } from '../modal-states/LSPAYModalContent'

export const Loading: FC = () => {
  return (
    <LSPAYModalContent>
      <div>
        <LoaderSpinner className="vd-mr3" small />
        Loading&hellip;
      </div>
    </LSPAYModalContent>
  )
}
